import React from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
import Footer from '@/Components/Footer';

export default function Guest({ app, children }) {
    return (
        <div id="wrapper">
            <header className="main-header">
                <div className="container">
                    <div className="header-holder d-flex align-items-center ">
                        <InertiaLink className="navbar-brand" href="/">
                            <img src={app.logo} alt={app.name} />
                        </InertiaLink>
                    </div>
                </div>
            </header>

            <main className="main">
                <div id="topAnchor"></div>
                {children}
            </main>

            <Footer />
        </div>
    )
}
